import gql from 'graphql-tag';

import type { SavedTalkingPoint } from 'src/data/annotation';
import { executeGqlQuery } from 'src/graphql/client';
import type { ID } from 'src/lib/collection';
import { getSingleProp } from 'src/lib/graphql';

const QUERY = gql`
  query TalkingPoints($customerId: ID!) {
    talkingPoints(customerId: $customerId) {
      id
      name
      score
      dataSource
      dataSourceName
      dataSourceAccountUrl
    }
  }
`;

export const queryTalkingPoints = async ({
  customerId,
}: {
  customerId: ID;
}): Promise<SavedTalkingPoint[]> => {
  const result = await executeGqlQuery({
    query: QUERY,
    variables: { customerId },
  });
  return getSingleProp(result.data) || [];
};
